import axios from 'axios'
import MaterialTable from "material-table"
import React , { useState, useEffect } from 'react'
import { Redirect } from 'react-router-dom'
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator'

import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Divider from '@material-ui/core/Divider'
import FormControl from '@material-ui/core/FormControl'
import Grid from '@material-ui/core/Grid'
import IconButton from "@material-ui/core/IconButton"
import InputAdornment from "@material-ui/core/InputAdornment"
import SearchIcon from "@material-ui/icons/Search"
import Select from '@material-ui/core/Select'
import Tooltip from '@material-ui/core/Tooltip'
import Typography from '@material-ui/core/Typography'
import VisibilityIcon from '@material-ui/icons/Visibility'
import { withStyles } from '@material-ui/core/styles'

import './ReminderExclusion.scss'
import Constants from '../../constants'
// import ShadowReport from './ShadowReport'
import { useUIContext } from '../../ContextLib/contextHooks'
import { Severity } from '../../ContextLib/CoreConsumer/Components/SnackbarMessage'
import Storage from '../../storage'
import { BottomNavigation } from '@material-ui/core'

export default function CoverHijackerlookup() {
    let componentId = "CoverHijackerlookup"
    const ui = useUIContext(componentId)
    const [searchTypeID, setSearchTypeID] = useState("coverkey")
    const [searchInput, setSearchInput] = useState("")
    const [data, setData] = useState([])
    const [showLoginData, setShowLoginData] = useState(false)
    const [CoverKey, setCoverKey] = useState(0)
    const [hijackStatus, setHijackStatus] = useState("")
	const [isHijackStatus, setIsHijackStatus] = useState(false)
    const [reasonInput, setReasonInput] = useState("")
    

    const searchOptions = [
        {key : "covername" , value : "Cover Name"},
        {key : "coverkey" , value : "Cover Key"},
        {key : "coverphone" , value : "Cover Phone"},
        {key : "coverlogin" , value : "Cover Login"},
        {key : "lockey" , value : "Location Key"},
     ]

    const columns = [
        { field: 'coverKey', title: 'Coverkey', width: 100 , editable: 'never', emptyValue: '-'},
        { field: 'orgName', title: 'Practice Name', width: 150  , editable: 'never' , emptyValue: '-', cellStyle: { textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden'}, render: dataRow => {return <HtmlTooltip title={dataRow.orgName} placement="top-start"><span>{dataRow.orgName}</span></HtmlTooltip>}},
        { field: 'status', title: 'Hijacker', width: 100 , editable: 'never', emptyValue: '-'},
       
    ]

    const HtmlTooltip = withStyles((theme) => ({
        tooltip: {
          backgroundColor: '#f5f5f9',
          color: 'rgba(0, 0, 0, 0.87)',
          maxWidth: 250,
          fontSize: theme.typography.pxToRem(16),
          border: '1px solid #dadde9',
          fontFamily:'Noto Sans, sans-serif',
        },
      }))(Tooltip)

    const componentDidMount = async () => {
        const user = Storage.getItem(Constants.currUserKey)
        let redirectToLogin = false
        if (user && user.jwt) {
          try {
            ui.ShowOverlay()
            const jwtCheckUrl = `${process.env.REACT_APP_ADMIN_API}/jwtCheck`
            await axios.get(jwtCheckUrl)
            ui.HideOverlay()
          }
          catch (error) {
            ui.ShowSnackbar(error, Severity.error)
            redirectToLogin = true
          }
        } 
        else {
            redirectToLogin = true
        }

        if (redirectToLogin) return <Redirect to={{ pathname: '/' }} />
    }       

    useEffect(() => {        
        componentDidMount()
    }, [])

    const onSubmit = async () => {
        try {
            ui.ShowOverlay()
            setReasonInput("")
            var request = {
                params: {
                  secretCode: `${process.env.REACT_APP_API_KEY}`,
                  coverKey: searchInput
                }
              }

              const url = `${process.env.REACT_APP_HIJACKERLOOKUP_API}/CoverHijackStatus`
           // const url = `$https://localhost:44331/api/CoverExclusion/CoverHijackStatus?secret=ditac-1&coverKey=4797'
              const res = await axios.get(url, request)
              let d = res.data
            
              if (res?.data.length > 0) { 
                  setData(d)  
                  console.log(d[0].status)
                  setHijackStatus(d[0].status)
				  if(d[0].status === 'Yes'){
					setIsHijackStatus(true)
				  }
				  else{
					setIsHijackStatus(false)
				  }
                }
              else { 
				  ui.ShowSnackbar("Cover does not exist in the database.", Severity.warning) 
                  setData([]) 
              }


        } catch (error) {
            ui.ShowSnackbar("Invalid search parameter! Please update search value and try again.", Severity.error)
            setData([]) 
        }
        setShowLoginData(false)
        ui.HideOverlay()
    }

    const onSubmitRemoveFromHijacker = async () => {
        try {
			if (hijackStatus === 'No') {
				ui.ShowOverlay()
				const userId = Storage.getItem('userId');
				const apiKey = `${process.env.REACT_APP_API_KEY}`
				const coverData = { 'coverKey': Number(searchInput), 'reason': reasonInput, 'createdDate': null, 'updatedDate': null, 'updatedBy': userId };
				const url = `${process.env.REACT_APP_HIJACKERLOOKUP_API}/deleteCoverExlcusionList?secretCode=${apiKey}`
				const res = await axios.post(url, coverData)
				let d = res.data

				if (res?.data && res.data === 1) {
					let data = res.data;
					ui.ShowSnackbar("Cover add to Hijacker successfully.", Severity.success)
					onSubmit()
				}
				else
				{
					ui.ShowSnackbar("Cover does not exist in the catalog.", Severity.warning)
				}
			}
			else {
				ui.ShowOverlay()
				const userId = Storage.getItem('userId');
				const apiKey = `${process.env.REACT_APP_API_KEY}`
				const coverData = { 'coverKey': data[0].coverKey, 'reason': reasonInput, 'createdDate': null, 'updatedDate': null, 'updatedBy': userId };
				const url = `${process.env.REACT_APP_HIJACKERLOOKUP_API}/upsertCoverExlcusionList?secretCode=${apiKey}`
				const res = await axios.post(url, coverData)
				let d = res.data

				if (res?.data) {
					let data = res.data;
					ui.ShowSnackbar("Cover remove from Hijacker successfully.", Severity.success)
					onSubmit()
				}
			}  
        } catch (error) {
            ui.ShowSnackbar("Error removing cover from hijacker please try again", Severity.error)
            setData([]) 
        }
        setShowLoginData(false)
        ui.HideOverlay()
    }


    const loadLoginDetails = (coverKey) => {
        ui.ShowOverlay()
        setData([]) 
        setCoverKey(coverKey)
        setShowLoginData(true)
        ui.HideOverlay()
    }

    

    const renderSearchText = () => {
          return  <TextValidator
          style={{width:"170px"}}
          id="searchInput"
          autoComplete="off"
          placeholder="Search Value"
          value={searchInput}
          onInput={e => setSearchInput(e.target.value)}  
          validators={['required']}
          errorMessages={['Search Value is required']}  
          InputProps={{
              disableUnderline: true,
              startAdornment: (
              <InputAdornment position="start">
                  <IconButton >
                  <SearchIcon />
                  </IconButton>
              </InputAdornment>
              ),
          }}
          />
      };

	const renderHijackRemovalForm = () => {
		let hijackerbtnName = ""
		if (hijackStatus === 'Yes') {
			hijackerbtnName = "Remove from Hijacker"
		}
		else {
			hijackerbtnName = "Add to Hijacker"
		}
		if (hijackStatus !== '') {
			
			return <div className="coverlookup">

				<div className="coverlookup-data">
					<ValidatorForm onSubmit={onSubmitRemoveFromHijacker} onError={errors => console.log(errors)} >
						<Grid container justify="flex-start" alignItems="center" spacing={2} className="search-option">
							{isHijackStatus ?
								<div className="search-fields">

									<Grid item>
										<TextValidator
											fullWidth
											id="reasonInput"
											autoComplete="off"
											placeholder="Enter Reason"
											value={reasonInput}

											onInput={e => setReasonInput(e.target.value)}
											validators={['required']}
											errorMessages={['Reason is required']}
											inputProps={{
												maxLength: 255,
											}}
											InputProps={{
												disableUnderline: true,
												
											}}
										/>
									</Grid>
								</div> : null
							}
							<Grid item>
								<Button
									//   style={{maxWidth: '300px' , minWidth: '100px'}} 
									variant="contained" color="primary" type="submit">
									{hijackerbtnName}
								</Button>
							</Grid>
						</Grid>
					</ValidatorForm>
				</div>
			</div >
		}
	}

    return( 
    <div className="coverlookup">
      <Box p={2} bgcolor="background.paper">
        <Grid container justify="flex-start" alignItems="center" spacing={2}>
            <Grid item>
                <Typography variant="h5">  
                Reminder Exclusion
                </Typography>
            </Grid>
        </Grid>
      </Box>

      <Divider />
      
      <Box p={4} bgcolor="background.paper" >
           
          <div className="coverlookup-data">
           
          <ValidatorForm onSubmit={onSubmit}  onError={errors => console.log(errors)} > 
          {/* {renderPhoneValidation()} */}
            <Grid container justify="flex-start" alignItems="center" spacing={2} className="search-option">
                <Grid item>
                    <Typography variant="h6">Enter CoverKey: </Typography>
                </Grid>

                <div className="search-fields">

                <Grid item>
                    {renderSearchText()}
                </Grid>
                </div>

                <Grid item>
                    <Button style={{maxWidth: '100px' , minWidth: '100px'}} variant="contained" color="primary" type="submit">
                    SEARCH
                    </Button>
                </Grid>
   

            </Grid>
          </ValidatorForm>
          
          <Divider />

 
            <MaterialTable
                    height="200"
                    columns={columns}
                    data={data}
                    options={{
                        pageSize: 1,
                        toolbar: false,
                        paging: false,
                        draggable: false,
                        sorting: false,
                        tableLayout: 'fixed',
                    }}       
                    />
            {renderHijackRemovalForm() }
          </div>

      </Box>
    </div >
    )
}